// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3699":"416d223e4e8405e0","4235":"f220bb0e6d9ad30a","7857":"400f25ec82bfc04c"}[chunkId] + ".js";
};